var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Odd",class:_vm.OddCssJudge},[_vm._v(" "+_vm._s(_vm.showOddValue)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }